import { BaseObject } from "./base-object.model";
import { BaseObjectApiFacade } from "./base-object.api-facade";
import { BaseObjectStoreFacade } from "./base-object.store-facade";
import { AppFacade } from "../../services/app-facade/app-facade.service";
import { IBaseObjectFacade } from "./base-object.facade.interface";

export abstract class BaseObjectFacade<T extends BaseObject, A extends BaseObjectApiFacade<T>, S extends BaseObjectStoreFacade<T>> implements IBaseObjectFacade{

    constructor(
        protected entityName: string,
        protected appFacade: AppFacade,
        protected apiFacade: A,
        protected storeFacade: S
    ) {
    }

    /**
     * Returns the name of the entity this facade handles
     * @return {string}
     */
    protected getEntity(): string {
        return this.entityName;
    }

    get api(): A {
        return this.apiFacade;
    }

    get store(): S {
        return this.storeFacade;
    }
}



// WEBPACK FOOTER //
// ./src/core/business-objects/base-object/base-object.facade.ts